export default __webpack_public_path__ + "static/Rock,-Brick,-Dirt-Dumpsters-edefe60bb63d0bd0815684c4c576f78b.jpg";